import { cva, VariantProps } from 'class-variance-authority'
import { cn } from '~/lib/utils'

const componentColour = cva('absolute left-0 w-s sm:w-m', {
  variants: {
    colour: {
      'ink-blue': 'fill-blue-d',
      'mid-blue': 'fill-blue-m',
      'light-blue': 'fill-blue-l',
      white: 'fill-white dark:fill-black'
    },
    userColour: {
      'ink-blue': 'fill-blue-d',
      'mid-blue': 'fill-blue-m',
      'light-blue': 'fill-blue-l',
      chartreuse: 'fill-char',
      'light-grey': 'fill-grey-l dark:fill-black',
      'light-aqua': 'fill-green',
      'light-purple': 'fill-purple',
      'light-orange': 'fill-orange',
      'light-pink': 'fill-pink',
      white: 'fill-white dark:fill-black'
    }
  }
})

type DynaH = {
  bgColour: VariantProps<typeof componentColour>['userColour']
  compColour: VariantProps<typeof componentColour>['colour']
  dynamicH: boolean
}

const DynamicH = ({ bgColour, compColour, dynamicH = false }: DynaH) => {
  const colour = compColour
  const userColour = bgColour

  return (
    <svg
      height='100%'
      width='100%'
      className={`${bgColour ? cn(componentColour({ userColour })) : cn(componentColour({ colour }))}`}
    >
      {dynamicH ? (
        <>
          <rect
            x={0}
            width='100%'
            height='100%'
            className='w-2xs-plus h-[calc(100%-36px)] sm:h-[calc(100%-40px)] md:h-[calc(100%-48px)] lg:w-xs'
          />
          <rect
            width='100%'
            height='100%'
            className='h-2xs-plus w-2xs-plus lg:h-xs translate-x-2xs-plus lg:translate-x-xs translate-y-[calc(100%-36px)] sm:translate-y-[calc(100%-40px)] md:translate-y-[calc(100%-48px)] lg:w-xs'
          />
          <rect
            x={0}
            width='100%'
            height='100%'
            className='h-s w-2xs-plus translate-y-[calc(100%-24px)] sm:h-[30px] sm:translate-y-[calc(100%-28px)] md:h-[36px] md:translate-y-[calc(100%-36px)] lg:h-[36px] lg:w-xs lg:translate-y-[calc(100%-32px)]'
          />
        </>
      ) : (
        <rect x={0} width='100%' height='100%' className='w-2xs-plus lg:w-xs' />
      )}
    </svg>
  )
}

export default DynamicH
